import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import eventAnalytics from "../../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../../utils/constants";

export class EmailLoginForm extends React.Component {
  constructor(props) {
    super(props);
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.EMAIL_LOGIN_FORM);
    eventAnalytics.publishViewPage(ANALYTIKA_EVENTS.PAGE.EMAIL_LOGIN_FORM);
  }

  render() {
    const { t, error, submitting } = this.props;
    return (
      <form data-request-type="email_login_submit" onSubmit={this.props.onSubmit}>
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        <LanguageSelector />
        <h1>{t("login:title")}</h1>


        {error && <div className="invalid show">{error}</div>}

        <div className="material-form-field">
          <input
            autoFocus
            type="email"
            autoComplete="off"
            id="email"
            name="email"
            onChange={this.props.onEmailChange}
            required={true}
          />
          <label className="material-form-field-label" htmlFor="email">
            {t("signup:email")}
          </label>
        </div>

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="verify-recover-btn"
          disabled={submitting}
        />

        <ReCaptcha />
      </form>
    );
  }
}

EmailLoginForm.propTypes = {
  t: Types.func.isRequired,
  state: Types.object.isRequired,
  error: Types.string,
  onEmailChange: Types.func.isRequired,
  onSubmit: Types.func.isRequired,
  submitting: Types.bool.isRequired,
};
export default withTranslation()(EmailLoginForm);
